export default __webpack_public_path__ + "static/media/owner.826dd76b.jpeg";